import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Password updated. Please log in."); navigate("/login"); }
    catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="reset-page">
      <div className="w-full max-w-sm">
        <Logo size={34} />
        <h1 className="font-heading font-bold text-2xl tracking-tight mt-8">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-destructive mt-3" data-testid="reset-no-token">Missing reset token. Please use the link from your email.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <Label htmlFor="pw">New password</Label>
              <Input id="pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" data-testid="reset-password-input" />
              <p className="text-xs text-muted-foreground mt-1">At least 8 characters, with a letter and a number.</p>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 brand-gradient text-white border-0" data-testid="reset-submit-btn">{loading ? "Saving..." : "Update password"}</Button>
          </form>
        )}
        <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary hover:underline">Back to login</Link></p>
      </div>
    </div>
  );
}
